"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const scale_1 = require("../../../utils/scale");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const IC_RIGHT_1 = __importDefault(require("../../../assets/icons/IC_RIGHT"));
const styles_1 = __importDefault(require("./styles"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const helpler_1 = require("../../../utils/helpler");
const images_1 = require("../../../assets/images");
const HashtagItem = (props) => {
    const { data, type } = props;
    const Avatar = (image, index) => {
        return (react_1.default.createElement(react_native_1.Pressable, { style: [
                {
                    marginLeft: index > 0 ? (0, scale_1.scale)(-7) : 0,
                    zIndex: data?.users.length - index,
                    width: (0, scale_1.scale)(25),
                    height: (0, scale_1.scale)(25),
                    borderRadius: 9999,
                    backgroundColor: 'white',
                    overflow: 'hidden',
                    padding: (0, scale_1.scale)(2)
                },
            ], key: index, onPress: () => {
                (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                    screen: Routes_1.default.USER_PROFILE,
                    params: {
                        userHandle: image.user_handle
                    }
                });
            } },
            react_1.default.createElement(react_native_1.Image, { source: image?.thumbnail_url ? image?.thumbnail_url : images_1.images?.AvatarDefaul, style: { flex: 1, borderRadius: 9999 }, resizeMode: 'cover' })));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                width: '100%',
                flexDirection: 'row',
                alignItems: 'center',
                borderBottomColor: '#DDDDDD',
                borderBottomWidth: 1,
                paddingVertical: (0, scale_1.scale)(12),
                paddingHorizontal: (0, scale_1.scale)(16),
            }, onPress: () => {
                (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                    screen: Routes_1.default.HASHTAG_DETAIL,
                    params: {
                        typeScreen: 0,
                        hashtag: data?.name,
                        typeHashTag: type == 0 ? 1 : type,
                    },
                });
            } },
            react_1.default.createElement(react_native_1.View, { style: {
                    width: (0, scale_1.scale)(300),
                } },
                data?.is_new == 1 && (react_1.default.createElement(react_native_1.View, { style: {
                        height: (0, scale_1.scale)(21),
                        width: (0, scale_1.scale)(42),
                        backgroundColor: '#44A06B',
                        borderRadius: (0, scale_1.scale)(3),
                        marginBottom: (0, scale_1.scale)(4),
                        justifyContent: 'center',
                        alignItems: 'center',
                    } },
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                            fontSize: (0, scale_1.moderateScale)(10),
                            lineHeight: (0, scale_1.moderateScale)(17),
                            color: '#FEFEFE',
                        } }, "NEW"))),
                react_1.default.createElement(CustomText_1.default, { style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#007AFF',
                    } }, data?.name),
                react_1.default.createElement(CustomText_1.default, { style: {
                        fontSize: (0, scale_1.moderateScale)(11),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#7C7C7C',
                        alignItems: 'center',
                    } },
                    (0, helpler_1.formatNumber)(data?.uses),
                    "\u4EF6"),
                data?.user_count > 0 && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.avatarList },
                    data?.users
                        ?.slice(0, 5)
                        .map((image, index) => Avatar(image, index)),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(11),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: '#7C7C7C',
                            marginLeft: 10,
                        } },
                        data?.user_count > 9999 ? '+9999' : data.user_count,
                        "\u4EBA\u304C\u5229\u7528")))),
            react_1.default.createElement(react_native_1.View, { style: {
                    marginLeft: (0, scale_1.scale)(30),
                } },
                react_1.default.createElement(IC_RIGHT_1.default, { width: (0, scale_1.scale)(10), height: (0, scale_1.scale)(17) })))));
};
exports.default = HashtagItem;
